import React, { useEffect, useState } from "react";
import { getUserProfile } from "../utilities/axios.utilities";
import "./Header.css";

interface IProps {
  setIsShowLogout: () => void;
}

const Header: React.FC<IProps> = ({ setIsShowLogout }) => {
  const [isShowMobile, setShowMobile] = useState(false);

  let userInfoString = localStorage.getItem("user_info");
  const userInfo = userInfoString ? JSON.parse(userInfoString) : null;
  
  const [userProfile, setUserProfile] = useState<any>(null);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const data = await getUserProfile();
        setUserProfile(data);
        localStorage.setItem("user_info", JSON.stringify({
          coins: data.coins,
          role: data.role,
          userName: data.username,
        }));
      } catch (err) {
        console.error("Error fetching user profile:", err);
      }
    };

    fetchProfile();
  }, []);


  return (
    <div className="w-full h-[80px]">
      <header
        className="menu-lobby py-3 px-8"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL || ""}/assets/bg-header.png)`,
        }}
      >
        <nav className="navbar navbar-expand-lg navbar-dark flex justify-between items-center">
          <a className="navbar-brand" href="/">
            <img
              src="/assets/logo.png"
              alt="logo"
              style={{ width: 489, height: 62, objectFit: "contain" }}
            />
          </a>
          <div className="menu">
            <div
              className={
                isShowMobile
                  ? "menu_wrapper menu_wrapper_active header-menu-use-assets"
                  : "menu_wrapper header-menu-use-assets"
              }
            >
              {/* Nút đóng menu - chỉ hiển thị khi menu active */}
              {isShowMobile && (
                <div 
                  className="menu-close-btn"
                  onClick={() => setShowMobile(false)}
                >
                  ✕
                </div>
              )}
              
              <a href="/" className="menu-item btn-home">
                <img src="/assets/home-icon.png" alt="" className="header-icon-img" />
                <p>Trang chủ</p>
              </a>
              <div className="menu-item btn-user">
                <img src="/assets/user-icon.png" alt="" className="header-icon-img" />
                <p>{userInfo?.userName ?? ""}</p>
              </div>
              <div className="menu-item btn-credit2 btn-redeem">
                <img src="/assets/coin-icon.png" alt="" className="header-icon-img" />
                <p>{userInfo?.coins ?? 0}</p>
              </div>

              <div
                className="menu-item btn-logout"
                onClick={() => {
                  setShowMobile(false);
                  setIsShowLogout();
                }}
              >
                <img src="/assets/logout-icon.png" alt="" className="header-icon-img" />
                <p>Đăng xuất</p>
              </div>
            </div>
            {/* Menu icon (3 sọc) - chỉ mobile */}
            <div className="block sm:hidden">
              <div
                className={`menu-icon ${isShowMobile ? 'change' : ''}`}
                onClick={() => setShowMobile(!isShowMobile)}
                aria-label="Mở menu"
                role="button"
              >
                <div className="bar1" />
                <div className="bar2" />
                <div className="bar3" />
              </div>
            </div>
          </div>
        </nav>
      </header>
    </div>
  );
};

export default Header;
